export const REACTION_EMOJIS = [
  '❤️',  // heart
  '🔥',  // fire
  '🪩',  // disco ball
  '⛄️',  // snowman
];